import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const ErrorContainer = styled.div`
  padding: 20px;
  text-align: center;
  color: #dc3545;
`;

export const StyledCheckbox = styled.input`
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  cursor: pointer;
  border: 1.5px solid #d1d5db;
  border-radius: 3px;
  background: #ffffff;
  position: relative;
  transition: all 0.2s ease;

  &:checked {
    background-color: #2d6cdf;
    border-color: #2d6cdf;
  }

  &:checked::after {
    content: '';
    position: absolute;
    left: 4px;
    top: 1px;
    width: 4px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  &:hover {
    border-color: #2d6cdf;
  }
`;

export const StatusBadge = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 0.5rem;
  font-size: 12px;
  font-weight: bold;
  border-radius: 20px;
  background-color: ${(props) => props.$color || '#e9ecef'};
  color: ${(props) => props.$textColor || '#495057'};
  cursor: pointer;
  gap: 5px;
`;

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StatusCircle = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.$color};
  flex-shrink: 0;
`;

export const LeadIdBadge = styled.span`
  padding: 5px 10px;
  background-color: #2d6cdf;
  border-radius: 10px;
  color: #ffffff;
  text-decoration: underline;
  display: inline-block;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
`;

export const LeadSourceWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SocialIconCircle = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
`;

export const AssigneeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UserIconContainer = styled.div`
  height: 21px;
  width: 21px;
  background: linear-gradient(135deg, #2d6cdf 0%, #4a8aff 100%);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ActionButton = styled.button`
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0056b3;
  }

  &:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
  }
`;

export const BulkActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const AssignButton = styled.button`
  height: 28px;
  padding: 0 16px;
  background: #15c7a71a;
  color: #15c7a7;
  border: none;
  border-radius: 22px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  cursor: pointer;
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.85;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    transform: none;
  }
`;

export const ReAssignButton = styled.button`
  height: 28px;
  padding: 0 16px;
  background: #fff0e5;
  color: #ff6a00;
  border: none;
  border-radius: 22px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  cursor: pointer;
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.85;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    transform: none;
  }
`;

export const TakeLeadButton = styled.button`
  height: 28px;
  padding: 0 16px;
  background: linear-gradient(90deg, #2768cb 31.73%, #224f91 100%);
  color: #ffffff;
  border: none;
  border-radius: 22px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  cursor: pointer;
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.85;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    transform: none;
  }
`;

export const Icon = styled.img``;

export const HoveredText = styled.span`
  cursor: default;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
